"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";

import "swiper/css/free-mode";
import "swiper/css/pagination";
import RevealElement from "../revealElement";
import ArrowButton from "../contact/arrowButton";
import WhiteArrow from "../../app/assets/white-arrow-up.svg";

type Career = {
    department: string;
    jobs: Jobs[];
};

type Jobs = {
    name: string;
    link: string;
};

export default function JobSlider({ slides }: { slides: Career }) {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);
    return (
        <>
            {isMounted ? (
                <RevealElement>
                    <Swiper
                        className="md:!hidden w-full !overflow-visible"
                        slidesPerView={1.2}
                        spaceBetween={20}
                        freeMode={true}
                        direction="horizontal"
                        modules={[FreeMode, Mousewheel]}
                        mousewheel={true}
                        breakpoints={{
                            565: {
                                slidesPerView: 1.8,
                                spaceBetween: 20,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                        }}
                    >
                        {slides.jobs.map((job: Jobs, j: number) => (
                            <SwiperSlide
                                key={`job-` + job.name + j}
                                className="relative w-full aspect-[360/240] !bg-gradient-to-b from-[#37DED7] to-[#32C5BF] rounded-3xl group"
                            >
                                <a
                                    href={job.link}
                                    key={`job` + j}
                                    className="absolute w-full h-full top-0 left-0 py-5 px-8 flex flex-col justify-between"
                                >
                                    <h3 className="text-2xl sm:text-3xl lg:text-font-32 font-bold text-white text-left">
                                        {job.name}
                                    </h3>
                                    <ArrowButton
                                        className="!mt-0 ml-auto"
                                        color="white"
                                    />
                                </a>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <div className="hidden flex-col md:grid grid-cols-3 gap-4">
                        {slides.jobs.map((job: Jobs, j: number) => (
                            <div
                                key={`job-` + job.name + j}
                                className="hidden md:block relative w-full h-[150px] aspect-[360/240] !bg-gradient-to-b from-[#37DED7] to-[#32C5BF] rounded-3xl group"
                            >
                                <a
                                    href={job.link}
                                    // target="_blank"
                                    key={`job` + j}
                                    className="absolute w-full h-full top-0 left-0 py-5 px-8 flex flex-col justify-between"
                                >
                                    <h3 className=" text-2xl sm:text-3xl lg:text-font-32 font-bold text-white text-left">
                                        {job.name}
                                    </h3>
                                    <ArrowButton
                                        className={`!mt-0 ml-auto`}
                                        color={"white"}
                                    />
                                </a>
                            </div>
                        ))}
                    </div>
                </RevealElement>
            ) : (
                <div className="inline-flex gap-4 w-full">
                    {[...Array(3)].map((_, j) => (
                        <div
                            key={j}
                            className="relative w-full aspect-[360/240] !bg-gradient-to-b from-[#37DED7] to-[#32C5BF] rounded-3xl opacity-40"
                        ></div>
                    ))}
                </div>
            )}
        </>
    );
}
